import { 
  Component, 
  OnInit,
  OnChanges,
  OnDestroy,
  Input,
  Output,
  SimpleChanges,
  EventEmitter,
  TemplateRef,
  ViewChild,
  NgZone,
  Inject,
  forwardRef
} from '@angular/core';

import { isEqual, isNil, isEmpty, set } from 'lodash-es';
import { Subject } from 'rxjs';
import { takeUntil, mergeMap, shareReplay } from 'rxjs/operators';
import { BaseComponent } from './components/base.component';
import { SharedModule } from './shared.module';import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DatexFormControl, validateControlOnChange, validateFormOnControlChange } from './models/datex-form-control';
import { Styles, ControlContainerStyles } from './models/style';
import { FieldModel } from './models/field';
import { FieldsetModel } from './models/fieldset';
import { ToolModel } from './models/tool';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles,
  ValueControlModel
} from './models/control';
import { datCodeValidator } from './components/code-validator.directive';import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { Totes_ShellService } from './Totes.shell.service';
import { Totes_OperationService } from './Totes.operation.service';
import { Totes_DatasourceService } from './Totes.datasource.index';
import { Totes_FlowService } from './Totes.flow.index';
import { Totes_FrontendFlowService } from './Totes.frontend.flow.service';
import { Totes_ReportService } from './Totes.report.index';
import { Totes_LocalizationService } from './Totes.localization.service';
import { Totes_totes_hub_ComponentContextService } from './Totes.totes_hub.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './Totes.frontend.types'
import { $frontendTypes as $types} from './Totes.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';

import { MatSelectChange } from '@angular/material/select';
import { TabItemModel, TabGroupModel } from './models/tab';
import { Totes_tote_containers_gridComponent } from './Totes.tote_containers_grid.component';
import { Totes_tote_types_gridComponent } from './Totes.tote_types_grid.component';
import { Totes_tote_container_statuses_gridComponent } from './Totes.tote_container_statuses_grid.component';

@Component({
  imports: [
    SharedModule,
    forwardRef(() => Totes_tote_containers_gridComponent),
    forwardRef(() => Totes_tote_types_gridComponent),
    forwardRef(() => Totes_tote_container_statuses_gridComponent),
  ],
  selector: 'Totes-totes_hub',
  templateUrl: './Totes.totes_hub.component.html'
})
export class Totes_totes_hubComponent extends BaseComponent implements OnInit, OnDestroy {


  @Input() showInDialog: boolean = false; 
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();  
  //#endregion Outputs
  hasToolbar: boolean = true;



  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  //#region Variables
  //#endregion
  formGroup: FormGroup = new FormGroup({
  });
  
  toolbar = {
  };

  actionbar = {
  };

 filters = {
  };


  filtersets = {
};

    rootTabGroup = new TabGroupModel();
  
    subTabGroups = {
    };
  
    onTabSelected(event: MatSelectChange) {
      event.value.activate();
    }
  
    tabs = {
      tote_containers: new TabItemModel(
        this.rootTabGroup, 
        'Containers', 
        false,
        ),
      tote_container_types: new TabItemModel(
        this.rootTabGroup, 
        'Types', 
        false,
        ),
      tote_statuses: new TabItemModel(
        this.rootTabGroup, 
        'Statuses', 
        false,
        ),
    };
  
  
    //#region tabs inParams
    //#endregion tabs inParams
  
    //#region tabs children
      @ViewChild('$tabs_tote_containers', { read: Totes_tote_containers_gridComponent }) $tabs_tote_containers: Totes_tote_containers_gridComponent;
      @ViewChild('$tabs_tote_container_types', { read: Totes_tote_types_gridComponent }) $tabs_tote_container_types: Totes_tote_types_gridComponent;
      @ViewChild('$tabs_tote_statuses', { read: Totes_tote_container_statuses_gridComponent }) $tabs_tote_statuses: Totes_tote_container_statuses_gridComponent;
    //#endregion tabs children


  get hubTitle(): string {
    const $hub = this;
    const $utils = this.$utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    return `Totes`;
  }

  get hubDescription(): string {
    const $hub = this;
    const $utils = this.$utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    return `Central station to configure your different tote types. `;
  }

  constructor(
  private $utils: UtilsService,
  private $settings: SettingsValuesService,
  private $shell: Totes_ShellService,
  private $datasources: Totes_DatasourceService,
  private $flows: Totes_FlowService,
  private $frontendFlows: Totes_FrontendFlowService,
  private $reports: Totes_ReportService,
  private $localization: Totes_LocalizationService,
  private $operations: Totes_OperationService,
  private $logger: CleanupLoggerService,
  private $context: Totes_totes_hub_ComponentContextService,
  ) { 
    super();
    this.$subscribeFormControlValueChanges();
    this.hasToolbar = !isEmpty(this.toolbar);

    //#region tabs tab init
    this.rootTabGroup.tabs = [
      this.tabs.tote_containers,
      this.tabs.tote_container_types,
      this.tabs.tote_statuses,
    ]; 
    //#endregion tabs tab init
  }

  ngOnInit(): void {
    this.$init();
  }
  

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }



  initialized = false;

  async $init() {
    this.title = 'Totes';
    
    const $hub = this;
    const $utils = this.$utils;



    this.initialized = true;
  }

  private $subscribeFormControlValueChanges() {
  }
  close() {
    this.$finish.emit();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = Promise.resolve(null);
    
    // children
    if (skipChildren === false) {
      this.$refreshChildren(childToSkip);
    }

    return result;
  }

  $refreshChildren(childToSkip: string) {
    //#region tabs children
    if (childToSkip !== '$tabs_tote_containers') {
      if (!isNil(this.$tabs_tote_containers) && !this.tabs.tote_containers.hidden) {
        this.$tabs_tote_containers.refresh(true, false, null);
      }
    }
    if (childToSkip !== '$tabs_tote_container_types') {
      if (!isNil(this.$tabs_tote_container_types) && !this.tabs.tote_container_types.hidden) {
        this.$tabs_tote_container_types.refresh(true, false, null);
      }
    }
    if (childToSkip !== '$tabs_tote_statuses') {
      if (!isNil(this.$tabs_tote_statuses) && !this.tabs.tote_statuses.hidden) {
        this.$tabs_tote_statuses.refresh(true, false, null);
      }
    }
    //#endregion tabs children
  }

  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }

}
